<template>
  <div class="app-wrapper">
    <div>
      <AppNavigationComponent
        :drawer="drawer"
        @input="drawer = $event" />

      <AppBarComponent @drawer-changed="drawer = $event" />

      <v-main
        v-if="paymentMethodsReady"
        class="main-content">
        <router-view />
      </v-main>

      <div
        v-else
        class="d-flex align-center justify-center mt-15 pt-15">
        <v-progress-circular
          :size="75"
          color="primary"
          indeterminate
          :width="4" />
      </div>
    </div>
  </div>
</template>

<script>
import AppNavigationComponent from '../components/layout/AppNavigationComponent.vue';
import AppBarComponent from '../components/layout/AppBarComponent.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    AppNavigationComponent,
    AppBarComponent,
  },

  data() {
    return {
      drawer: false,
      paymentMethodsReady: false,
    };
  },

  created() {
    this.fetchPaymentMethods();
  },

  methods: {
    ...mapActions({
    }),

    async fetchPaymentMethods() {
      this.paymentMethodsReady = true;
    },
  },
};
</script>

<style lang="scss">
.main-content > .v-main__wrap > .container {
  padding-bottom: 80px !important;
}

.app-wrapper {
  @media screen and (max-width: 992px) {
    overflow-x: scroll;
  }
}

.app {
  min-width: 992px;
}

.v-list-group__header.v-list-item.v-list-item--link.theme--light {
  padding: 0 32px 0 8px;
}

.v-list-item__icon.v-list-group__header__prepend-icon {
  order: 1;
}
</style>
